/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react"
// import RichTextResolver from "storyblok-js-client/dist/rich-text-resolver.es"

import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import Components from "../../components/index"
import { objectToHTML } from "../../helpers/objectToHTML"

import PropTypes from "prop-types"
import * as Icon from "react-feather"
import { uniqueId } from "lodash"

import {
  StyledCheckbox,
  StyledCheckValidation,
  StyledCrossValidation,
  StyledCheckboxWrapper,
} from "./partials"

// const resolver = new RichTextResolver()

const Checkbox = ({
  id,
  value,
  name,
  label,
  onChange,
  disable,
  hidden,
  checked,
  required,
  isValid,
  isDark,
  richText,
  loading,
}) => {
  const htmlId = uniqueId(id)

  function handleClick() {
    // !value is used as its been toggled by the user
    const valid = required ? required && !value : true
    onChange(id, { value: !value, valid: valid })
  }

  const showValidStyle = required ? isValid : undefined

  let html = undefined
  let parsedLabel
  let markupString

  if (label) {
    try {
      parsedLabel = JSON.parse(label)
      if (parsedLabel && parsedLabel.content) {
        markupString = objectToHTML(parsedLabel.content)
      } else {
        console.error(
          'Parsed JSON does not have the expected "content" property:',
          parsedLabel
        )
      }
    } catch (error) {
      console.error("Error parsing JSON:", error)
    }
  } else {
    console.error("Label is empty or undefined.")
  }

  return (
    <StyledCheckboxWrapper
      data-name="field-checkbox"
      isDark={isDark}
      loading={loading}
    >
      <StyledCheckbox isDark={isDark} valid={showValidStyle}>
        <div onClick={handleClick}>
          <input
            id={htmlId}
            type="checkbox"
            required={required}
            disabled={loading ? "disabled" : disable}
            hidden={hidden}
            checked={checked}
            value={value}
            onChange={(e) => {
              const { value, checked } = e.target
            }}
          />
          {value && <Icon.Check />}
        </div>
        {label && !richText && <label htmlFor={htmlId}>{label}</label>}
        {richText && (
          <label htmlFor={htmlId}>
            {
              unified()
                .use(remarkParse)
                .use(remarkRehype)
                .use(rehypeReact, {
                  createElement: React.createElement,
                  components: remarkReactComponents,
                  Fragment: React.Fragment,
                })
                .processSync(markupString).result
            }
          </label>
        )}
      </StyledCheckbox>
    </StyledCheckboxWrapper>
  )
}

Checkbox.defaultProps = {
  label: "",
  name: "",
  disable: false,
  hidden: false,
  value: false,
  onChange: () => {},
  checked: false,
  required: false,
  isValid: undefined,
  loading: false,
}

Checkbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  disable: PropTypes.bool,
  hidden: PropTypes.bool,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  isValid: PropTypes.bool,
  richText: PropTypes.bool,
  loading: PropTypes.bool,
}

export default Checkbox
